module.exports = __webpack_public_path__ + "img/turbo_on.ad31b9b3.png";